import $ from 'jquery'
import Control from 'ol/control/Control'
/**
 * Undo Vertex class
 *
 * @param {Object} config
 * @constructor
 */
export default class UndoVertext {
  constructor(drawInteraction, map) {
    this.drawInteraction = drawInteraction
    this.map = map

    this.$popover = $(
      `<div class="popover top in undo-vertex-modal" style="margin:0">
				<div class="popover-content"></div>
			</div>`
    ).css({
      width: 260,
      'min-width': 'initial',
      'max-width': 'initial',
      'margin-top': 5,
      left: 'calc(50% - 90px)',
      position: 'absolute',
      top: 67
    })

    this.control = new Control({
      element: this.$popover.get(0)
    })

    this.$undoButton = $(
      `<button class="btn btn-primary btn-block" style="width:initial; float:left;"><i class="fa fa-undo" ></i>Ångra</button>`
    )
      .css({
        marginTop: 5,
        marginBottom: 5
      })
      .appendTo(this.$popover.find('.popover-content:first'))
      .on('click', this.handleUnduButtonClick.bind(this))

    this.$cancelButton = $(
      `<button class="btn btn-default btn-block" style="width:initial; float:right;">Avbryt</button>`
    )
      .css({
        marginTop: 5,
        marginBottom: 5,
        display: 'initial'
      })
      .appendTo(this.$popover.find('.popover-content:first'))
      .on('click', this.handleCancelButtonClick.bind(this))
  }

  handleCancelButtonClick() {
    this.drawInteraction.setActive(false)
    this.drawInteraction.setActive(true)
    this.deactivate()
  }

  handleUnduButtonClick() {
    this.drawInteraction.removeLastPoint()
  }

  activate() {
    this.map.addControl(this.control)
  }

  deactivate() {
    this.map.removeControl(this.control)
  }
}
